/* eslint-disable */
import React, { useState, useContext, useEffect } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { AuthContext } from "../contexts/AuthContext";
import { Dropdown, DropdownButton, Form, Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import es from "date-fns/locale/es";
import weekday from 'dayjs/plugin/weekday';
import ReactLoading from 'react-loading';
import * as XLSX from 'xlsx';
import "react-datepicker/dist/react-datepicker.css";
import "../index.css";
import "./Apointment/Apointment.css";

registerLocale("es", es);
dayjs.extend(weekday)

// "Tratamiento" especial dentro de cuenta donde viven los copagos, ya que no
// están ligados a ningún procedimiento real. Siempre queda con cargos: []
// así que su saldo es $0 y no afecta el saldo total.
const TRATAMIENTO_COPAGOS = "Copagos";

// Estilos simples e inline para que el componente sea autocontenido
const styles = {
    formRow: {
        display: "flex",
        flexWrap: "wrap",
        gap: "10px",
        alignItems: "center",
        marginBottom: "20px",
        paddingBottom: "15px",
        borderBottom: "2px solid #eee"
    },
    input: {
        border: "1px solid #ccc",
        borderRadius: "4px",
        padding: "6px 10px",
        resize: "none",
        width: "140px"
    },
    itemCard: {
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "12px 15px",
        marginBottom: "12px",
        backgroundColor: "#fafafa"
    },
    itemHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "8px"
    },
    movRow: {
        display: "flex",
        justifyContent: "space-between",
        fontSize: "14px",
        padding: "4px 0",
        borderBottom: "1px dashed #e0e0e0",
        color: "#555"
    },
    saldoDebe: {
        color: "#c0392b",
        fontWeight: "bold"
    },
    saldoSaldado: {
        color: "#27ae60",
        fontWeight: "bold"
    },
    totalBox: {
        marginTop: "20px",
        padding: "15px",
        backgroundColor: "#f1f1f1",
        borderRadius: "8px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: "18px",
        fontWeight: "bold"
    },
    deleteLink: {
        color: "#c0392b",
        cursor: "pointer",
        fontSize: "13px"
    },
    deleteMovLink: {
        color: "#e67e22",
        cursor: "pointer",
        fontSize: "12px",
        marginLeft: "10px"
    },
    buttonGroup: {
        display: "flex",
        gap: "10px",
        marginTop: "15px",
        flexWrap: "wrap"
    }
};

function Cuenta(props) {
    const { user1, isAuth } = useContext(AuthContext);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    let USERPATCH = `${process.env.REACT_APP_API}editusers`;

    const [show, setShow] = useState(false);
    const [guardando, setGuardando] = useState(false);

    const [fecha, setFecha] = useState(new Date());
    const [tipo, setTipo] = useState("Tipo de movimiento");
    const [formaPago, setFormaPago] = useState("Forma de pago");
    const [tratamiento, setTratamiento] = useState("");
    const [tratamientoSeleccionado, setTratamientoSeleccionado] = useState("Selecciona tratamiento");
    const [cantidad, setCantidad] = useState("");
    const [doctorSeleccionado, setDoctorSeleccionado] = useState(null);

    // Estado de la cuenta: array de tratamientos, cada uno con sus cargos, pagos y copagos.
    // Se normaliza para que items guardados antes de este cambio también tengan `copagos`.
    const [cuenta, setCuenta] = useState((props.user.cuenta || []).map(item => ({ ...item, copagos: item.copagos || [] })));

    function limpiarFormulario() {
        setTipo("Tipo de movimiento");
        setFormaPago("Forma de pago");
        setTratamiento("");
        setTratamientoSeleccionado("Selecciona tratamiento");
        setCantidad("");
        setDoctorSeleccionado(null);
        setFecha(new Date());
    }

    function calcularSaldo(item) {
        const totalCargos = item.cargos.reduce((acc, c) => acc + Number(c.cantidad), 0);
        const totalPagos = item.pagos.reduce((acc, p) => acc + Number(p.cantidad), 0);
        return totalCargos - totalPagos;
    }

    function calcularSaldoTotal() {
        return cuenta.reduce((acc, item) => acc + calcularSaldo(item), 0);
    }

    function agregarMovimiento() {
        if (!cantidad || Number(cantidad) <= 0) {
            Swal.fire("Error", "Ingresa una cantidad válida", "error");
            return;
        }

        if (tipo === "Cargo") {
            if (!tratamiento.trim()) {
                Swal.fire("Error", "Escribe el nombre del tratamiento", "error");
                return;
            }

            if (!doctorSeleccionado) {
                Swal.fire("Error", "Selecciona el odontólogo", "error");
                return;
            }

            setCuenta(prev => {
                const copia = [...prev];
                const idx = copia.findIndex(i => i.tratamiento === tratamiento.trim());
                const nuevoCargo = { fecha: dayjs(fecha).format('DD-MM-YYYY'), cantidad: Number(cantidad), odontologo: doctorSeleccionado };

                if (idx >= 0) {
                    copia[idx] = { ...copia[idx], cargos: [...copia[idx].cargos, nuevoCargo] };
                } else {
                    copia.push({ tratamiento: tratamiento.trim(), cargos: [nuevoCargo], pagos: [], copagos: [] });
                }

                return copia;
            });

        } else if (tipo === "Copago") {
            if (!doctorSeleccionado) {
                Swal.fire("Error", "Selecciona el odontólogo", "error");
                return;
            }

            // Los copagos no están ligados a ningún procedimiento, así que se
            // guardan dentro del "tratamiento" especial TRATAMIENTO_COPAGOS,
            // que siempre queda con cargos: [] y por lo tanto saldo $0.
            setCuenta(prev => {
                const copia = [...prev];
                const idx = copia.findIndex(i => i.tratamiento === TRATAMIENTO_COPAGOS);
                const nuevoCopago = { fecha: dayjs(fecha).format('DD-MM-YYYY'), cantidad: Number(cantidad), odontologo: doctorSeleccionado, formaPago };

                if (idx >= 0) {
                    copia[idx] = { ...copia[idx], copagos: [...copia[idx].copagos, nuevoCopago] };
                } else {
                    copia.push({ tratamiento: TRATAMIENTO_COPAGOS, cargos: [], pagos: [], copagos: [nuevoCopago] });
                }

                return copia;
            });

        } else if (tipo === "Pago") {
            if (tratamientoSeleccionado === "Selecciona tratamiento") {
                Swal.fire("Error", "Selecciona a qué tratamiento aplica el pago", "error");
                return;
            }

            if (formaPago === "Forma de pago") {
                Swal.fire("Error", "Selecciona la forma de pago", "error");
                return;
            }

            setCuenta(prev => {
                const copia = [...prev];
                const idx = copia.findIndex(i => i.tratamiento === tratamientoSeleccionado);
                if (idx < 0) return prev;

                const nuevoPago = { fecha: dayjs(fecha).format('DD-MM-YYYY'), formaPago, cantidad: Number(cantidad) };

                copia[idx] = { ...copia[idx], pagos: [...copia[idx].pagos, nuevoPago] };

                return copia;
            });

        } else {
            Swal.fire("Error", "Selecciona el tipo de movimiento (Cargo, Pago o Copago)", "error");
            return;
        }

        limpiarFormulario();
    }

    function eliminarTratamiento(nombreTratamiento) {
        Swal.fire({
            title: `¿Eliminar "${nombreTratamiento}" de la cuenta?`,
            text: "Esto quitará todos sus cargos y pagos registrados.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar"
        }).then((result) => {
            if (result.isConfirmed) {
                setCuenta(prev => prev.filter(i => i.tratamiento !== nombreTratamiento));
            }
        });
    }

    function eliminarMovimiento(nombreTratamiento, index, tipoMovimiento) {
        Swal.fire({
            title: `¿Eliminar este ${tipoMovimiento}?`,
            text: `Se eliminará el ${tipoMovimiento.toLowerCase()} del tratamiento "${nombreTratamiento}"`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar"
        }).then((result) => {
            if (result.isConfirmed) {
                setCuenta(prev => {
                    const copia = [...prev];
                    const idx = copia.findIndex(i => i.tratamiento === nombreTratamiento);
                    if (idx >= 0) {
                        if (tipoMovimiento === "cargo") {
                            copia[idx].cargos = copia[idx].cargos.filter((_, i) => i !== index);
                        } else if (tipoMovimiento === "pago") {
                            copia[idx].pagos = copia[idx].pagos.filter((_, i) => i !== index);
                        } else if (tipoMovimiento === "copago") {
                            copia[idx].copagos = copia[idx].copagos.filter((_, i) => i !== index);
                        }
                        // Si el tratamiento queda sin movimientos, lo eliminamos
                        if (copia[idx].cargos.length === 0 && copia[idx].pagos.length === 0 && copia[idx].copagos.length === 0) {
                            copia.splice(idx, 1);
                        }
                    }
                    return copia;
                });
            }
        });
    }

    function guardarEnDB() {
        setGuardando(true);

        const payload = {
            cuenta: cuenta // Enviar el estado actual de cuenta (incluye cargos, pagos y copagos)
        };

        axios.patch(`${USERPATCH}/${user1.id}/${props.user._id}`, payload,
            {
                headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
            })
            .then((res) => {
                // Actualizar el estado local del padre
                if (props.data1 && props.setData1) {
                    const indexUsuario = props.data1.findIndex(x => x._id === props.user._id);
                    if (indexUsuario !== -1) {
                        // Crear una copia profunda del array
                        const newData = props.data1.map((user, idx) => {
                            if (idx === indexUsuario) {
                                return {
                                    ...user,
                                    cuenta: cuenta // Usar el estado actual
                                };
                            }
                            return user;
                        });

                        // Actualizar el estado del padre
                        props.setData1(newData);
                    }
                }

                setGuardando(false);
                Swal.fire({
                    icon: 'success',
                    title: '¡Guardado!',
                    text: 'La cuenta se guardó correctamente',
                    timer: 2000,
                    showConfirmButton: true
                });
            })
            .catch((error) => {
                setGuardando(false);
                console.error('Error al guardar:', error);

                let mensajeError = 'No se pudo guardar la cuenta';
                if (error.response && error.response.data && error.response.data.message) {
                    mensajeError = error.response.data.message;
                }

                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: mensajeError
                });
            });
    }

    // Función para exportar a Excel
    function exportarExcel(tipo = 'todos') {
        if (cuenta.length === 0) {
            Swal.fire("Error", "No hay datos para exportar", "error");
            return;
        }

        try {
            // Preparar datos para el Excel
            const data = [];
            let totalGeneral = 0;

            // Si es un solo tratamiento, filtrar
            const tratamientosAEvaluar = tipo === 'todos'
                ? cuenta
                : cuenta.filter(item => item.tratamiento === tipo);

            if (tratamientosAEvaluar.length === 0) {
                Swal.fire("Error", "No se encontró el tratamiento", "error");
                return;
            }

            tratamientosAEvaluar.forEach((item, idx) => {
                const saldo = calcularSaldo(item);
                totalGeneral += saldo;

                // Título del tratamiento
                data.push({
                    'Tratamiento': `${idx > 0 ? '' : ''}`,
                    'Concepto': `** ${item.tratamiento} **`,
                    'Fecha': '',
                    'Forma de Pago': '',
                    'Cantidad': '',
                    'Saldo': saldo.toFixed(2)
                });

                // Agregar cargos
                if (item.cargos.length > 0) {
                    item.cargos.forEach(c => {
                        const nombreDoc = c.odontologo ? ` - Dr(a). ${c.odontologo.nombre} ${c.odontologo.apellido}` : '';
                        data.push({
                            'Tratamiento': '',
                            'Concepto': `CARGO${nombreDoc}`,
                            'Fecha': c.fecha,
                            'Forma de Pago': '',
                            'Cantidad': c.cantidad.toFixed(2),
                            'Saldo': ''
                        });
                    });
                }

                // Agregar pagos
                if (item.pagos.length > 0) {
                    item.pagos.forEach(p => {
                        data.push({
                            'Tratamiento': '',
                            'Concepto': `PAGO (${p.formaPago})`,
                            'Fecha': p.fecha,
                            'Forma de Pago': p.formaPago,
                            'Cantidad': (-p.cantidad).toFixed(2),
                            'Saldo': ''
                        });
                    });
                }

                // Agregar copagos (no afectan el saldo, solo quedan como registro)
                if (item.copagos && item.copagos.length > 0) {
                    item.copagos.forEach(cp => {
                        const nombreDoc = cp.odontologo ? ` - Dr(a). ${cp.odontologo.nombre} ${cp.odontologo.apellido}` : '';
                        data.push({
                            'Tratamiento': '',
                            'Concepto': `COPAGO${nombreDoc}`,
                            'Fecha': cp.fecha,
                            'Forma de Pago': '',
                            'Cantidad': Number(cp.cantidad).toFixed(2),
                            'Saldo': ''
                        });
                    });
                }

                // Agregar una línea vacía entre tratamientos
                if (idx < tratamientosAEvaluar.length - 1) {
                    data.push({
                        'Tratamiento': '',
                        'Concepto': '',
                        'Fecha': '',
                        'Forma de Pago': '',
                        'Cantidad': '',
                        'Saldo': ''
                    });
                }
            });

            // Agregar el total general
            data.push({
                'Tratamiento': '',
                'Concepto': '=== TOTAL GENERAL ===',
                'Fecha': '',
                'Forma de Pago': '',
                'Cantidad': '',
                'Saldo': totalGeneral.toFixed(2)
            });

            // Crear hoja de trabajo
            const ws = XLSX.utils.json_to_sheet(data);

            // Ajustar ancho de columnas
            ws['!cols'] = [
                { wch: 25 },
                { wch: 20 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 }
            ];

            // Crear libro de trabajo
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Cuenta");

            // Generar nombre del archivo
            const fechaActual = dayjs().format('DD-MM-YYYY');
            const nombreArchivo = tipo === 'todos'
                ? `Cuenta_${props.user.nombre}_${props.user.apellido}_${fechaActual}.xlsx`
                : `Tratamiento_${tipo}_${props.user.nombre}_${props.user.apellido}_${fechaActual}.xlsx`;

            // Descargar archivo
            XLSX.writeFile(wb, nombreArchivo);

            Swal.fire("Éxito", `Excel exportado correctamente`, "success");
        } catch (error) {
            console.error('Error exportando Excel:', error);
            Swal.fire("Error", "No se pudo exportar el Excel", "error");
        }
    }

    const saldoTotal = calcularSaldoTotal();

    return (
        <>
            {isAuth ? (
                user1.role === "admin" || user1.role === "secre" ? (
                    <>
                        <Modal show={show} size="xl" fullscreen={true} onHide={handleClose}>
                            <Modal.Header closeButton>
                                <Modal.Title>Cuenta de {props.user.nombre} {props.user.apellido}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form>
                                    {/* Formulario para agregar cargos o pagos */}
                                    <div style={styles.formRow}>
                                        <div>
                                            <Form.Label>Fecha</Form.Label>
                                            <DatePicker locale="es" selected={fecha} onChange={(date) => setFecha(date)} />
                                        </div>

                                        <DropdownButton variant="outline-info" title={tipo}>
                                            <Dropdown.Item onClick={() => { setTipo("Cargo") }}><h4 className="alineacion">Cargo</h4></Dropdown.Item>
                                            <Dropdown.Item onClick={() => { setTipo("Pago") }}><h4 className="alineacion">Pago</h4></Dropdown.Item>
                                            <Dropdown.Item onClick={() => { setTipo("Copago") }}><h4 className="alineacion">Copago</h4></Dropdown.Item>
                                        </DropdownButton>

                                        {(tipo === "Cargo" || tipo === "Copago") &&
                                            <DropdownButton
                                                variant="outline-secondary"
                                                title={doctorSeleccionado ? `${doctorSeleccionado.nombre} ${doctorSeleccionado.apellido}` : "Selecciona odontólogo"}
                                                disabled={props.doctores.length === 0}
                                            >
                                                {props.doctores.map((doc) => (
                                                    <Dropdown.Item key={doc._id} onClick={() => setDoctorSeleccionado(doc)}>
                                                        <h4 className="alineacion">{doc.nombre} {doc.apellido}</h4>
                                                    </Dropdown.Item>
                                                ))}
                                            </DropdownButton>
                                        }

                                        {(tipo === "Pago" || tipo === "Copago") &&
                                            <DropdownButton variant="outline-info" title={formaPago}>
                                                <Dropdown.Item onClick={() => { setFormaPago("Transferencia") }}><h4 className="alineacion">Transferencia</h4></Dropdown.Item>
                                                <Dropdown.Item onClick={() => { setFormaPago("Efectivo") }}><h4 className="alineacion">Efectivo</h4></Dropdown.Item>
                                                <Dropdown.Item onClick={() => { setFormaPago("TC") }}><h4 className="alineacion">Tarjeta de credito</h4></Dropdown.Item>
                                                <Dropdown.Item onClick={() => { setFormaPago("TD") }}><h4 className="alineacion">Tarjeta de debito</h4></Dropdown.Item>
                                                <Dropdown.Item onClick={() => { setFormaPago("Cheque") }}><h4 className="alineacion">Cheque</h4></Dropdown.Item>
                                                <Dropdown.Item onClick={() => { setFormaPago("Qr") }}><h4 className="alineacion">Qr</h4></Dropdown.Item>
                                                <Dropdown.Item onClick={() => { setFormaPago("Mercado Pago") }}><h4 className="alineacion">Mercado Pago</h4></Dropdown.Item>
                                                <Dropdown.Item onClick={() => { setFormaPago("Otro") }}><h4 className="alineacion">Otro</h4></Dropdown.Item>
                                            </DropdownButton>
                                        }

                                        {tipo === "Cargo" &&
                                            <textarea
                                                style={styles.input}
                                                placeholder="Tratamiento"
                                                rows="1"
                                                value={tratamiento}
                                                onChange={(e) => { setTratamiento(e.target.value); }}
                                            />
                                        }

                                        {tipo === "Pago" &&
                                            <DropdownButton variant="outline-secondary" title={tratamientoSeleccionado} disabled={cuenta.filter(i => i.tratamiento !== TRATAMIENTO_COPAGOS).length === 0}>
                                                {cuenta.filter(i => i.tratamiento !== TRATAMIENTO_COPAGOS).map((item, idx) => (
                                                    <Dropdown.Item key={idx} onClick={() => setTratamientoSeleccionado(item.tratamiento)}>
                                                        <h4 className="alineacion">{item.tratamiento}</h4>
                                                    </Dropdown.Item>
                                                ))}
                                            </DropdownButton>
                                        }

                                        <input
                                            type="number"
                                            style={styles.input}
                                            placeholder="Cantidad"
                                            value={cantidad}
                                            onChange={(e) => { setCantidad(e.target.value); }}
                                        />

                                        <Button onClick={agregarMovimiento}>Agregar</Button>
                                    </div>

                                    {/* Lista de tratamientos con sus cargos, pagos y saldo */}
                                    {cuenta.length === 0 && (
                                        <p style={{ color: "#888" }}>Aún no hay movimientos registrados.</p>
                                    )}

                                    {cuenta.map((item, index) => {
                                        const saldo = calcularSaldo(item);
                                        return (
                                            <div style={styles.itemCard} key={index}>
                                                <div style={styles.itemHeader}>
                                                    <h5 style={{ margin: 0 }}>{item.tratamiento}</h5>
                                                    <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                                                        <span style={saldo > 0 ? styles.saldoDebe : styles.saldoSaldado}>
                                                            Saldo: ${saldo.toFixed(2)}
                                                        </span>
                                                        <span style={styles.deleteLink} onClick={() => eliminarTratamiento(item.tratamiento)}>
                                                            Eliminar
                                                        </span>
                                                    </div>
                                                </div>

                                                {item.cargos.map((c, i) => (
                                                    <div style={styles.movRow} key={`cargo-${i}`}>
                                                        <span>Cargo{c.odontologo ? ` - Dr(a). ${c.odontologo.nombre} ${c.odontologo.apellido}` : ''}</span>
                                                        <span>{c.fecha}</span>
                                                        <span>${Number(c.cantidad).toFixed(2)}</span>
                                                        <span
                                                            style={styles.deleteMovLink}
                                                            onClick={() => eliminarMovimiento(item.tratamiento, i, 'cargo')}
                                                        >
                                                            ✕
                                                        </span>
                                                    </div>
                                                ))}

                                                {item.pagos.map((p, i) => (
                                                    <div style={styles.movRow} key={`pago-${i}`}>
                                                        <span>Pago ({p.formaPago})</span>
                                                        <span>{p.fecha}</span>
                                                        <span>-${Number(p.cantidad).toFixed(2)}</span>
                                                        <span
                                                            style={styles.deleteMovLink}
                                                            onClick={() => eliminarMovimiento(item.tratamiento, i, 'pago')}
                                                        >
                                                            ✕
                                                        </span>
                                                    </div>
                                                ))}

                                                {item.copagos && item.copagos.map((cp, i) => (
                                                    <div style={styles.movRow} key={`copago-${i}`}>
                                                        <span>Copago{cp.odontologo ? ` - Dr(a). ${cp.odontologo.nombre} ${cp.odontologo.apellido}` : ''}</span>
                                                        <span>{cp.fecha}</span>
                                                        <span>${Number(cp.cantidad).toFixed(2)}</span>
                                                        <span
                                                            style={styles.deleteMovLink}
                                                            onClick={() => eliminarMovimiento(item.tratamiento, i, 'copago')}
                                                        >
                                                            ✕
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        );
                                    })}

                                    {/* Saldo total */}
                                    <div style={styles.totalBox}>
                                        <span>Saldo a pagar</span>
                                        <span style={saldoTotal > 0 ? styles.saldoDebe : styles.saldoSaldado}>
                                            ${saldoTotal.toFixed(2)}
                                        </span>
                                    </div>

                                    {/* Botones de exportación y guardado */}
                                    <div style={styles.buttonGroup}>
                                        <Button variant="success" onClick={guardarEnDB} disabled={guardando}>
                                            {guardando ? 'Guardando...' : 'Guardar cambios'}
                                        </Button>

                                        <Button variant="info" onClick={() => exportarExcel('todos')}>
                                            Exportar Todo a Excel
                                        </Button>

                                        {cuenta.length > 0 && (
                                            <DropdownButton variant="warning" title="Exportar Tratamiento">
                                                {cuenta.map((item, idx) => (
                                                    <Dropdown.Item
                                                        key={idx}
                                                        onClick={() => exportarExcel(item.tratamiento)}
                                                    >
                                                        {item.tratamiento}
                                                    </Dropdown.Item>
                                                ))}
                                            </DropdownButton>
                                        )}
                                    </div>
                                </Form>
                            </Modal.Body>
                        </Modal>

                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="button-tooltip">Cuenta</Tooltip>}
                        >
                            <Button className={saldoTotal == 0 ? "btn btn-secondary" : saldoTotal > 0 ? "btn btn-danger" : "btn btn-success"} onClick={handleShow}>
                                <i className="fa-solid fa-money-check-dollar"></i>
                            </Button>
                        </OverlayTrigger>
                    </>
                ) : null
            ) : undefined
            }
        </>
    )
}

export default Cuenta